<template>
  <div>
    <ValidationObserver v-show="!isShowLoading" v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Đối tượng xử lý<span class="text-danger">*</span></label>
                <ValidationProvider name="Đối tượng xử lý" rules="required|max:30" v-slot="{ errors,classes }"
                                    vid="processing_object">
                  <el-input placeholder="Nhập đối tượng xử lý" v-model="schedule.processing_object"></el-input>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Thời gian bắt đầu<span class="text-danger">*</span></label>
                <ValidationProvider name="Thời gian bắt đầu" rules="required" v-slot="{ errors,classes }"
                                    vid="schedule">
                  <date-picker
                      @change="onStartDateChanged"
                      v-model="schedule.schedule"
                      type="datetime"
                      :disabled-date="disabledBeforeStartDate"
                      placeholder="Thời gian bắt đầu"
                      :time-picker-options="time_picker_options"
                      :disabled-time="disableOptionTimeStart"
                  >
                  </date-picker>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Thời gian kết thúc<span class="text-danger">*</span></label>
                <ValidationProvider name="Thời gian kết thúc" rules="required" v-slot="{ errors,classes }"
                                    vid="end_schedule">
                  <date-picker
                      :disabled="isDisableTimeEnd"
                      @change="onEndDateChanged"
                      v-model="schedule.end_schedule"
                      :disabled-date="disabledBeforeEndDate"
                      type="datetime"
                      placeholder="Thời gian kết thúc"
                      :time-picker-options="time_picker_options_end"
                      :disabled-time="disableOptionTimeEnd"
                  >
                  </date-picker>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Người phụ trách<span class="text-danger">*</span></label>
                <ValidationProvider name="Chọn người phụ trách" rules="required" v-slot="{ errors,classes }"
                                    vid="tester_id">
                  <el-select
                      v-model="schedule.tester_id"
                      filterable
                      placeholder="Người phụ trách"
                      clearable
                      :disabled="isDisableTester"
                  >
                    <el-option
                        v-for="item in testers"
                        :key="item.id"
                        :label="`${item.name} - ${item.phone}`"
                        :value="item.id">
                    </el-option>
                  </el-select>
                  <div class="fv-plugins-message-container">
                    <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-secondary mr-2" @click="comeBack">Quay Lại</button>
            <button type="button" class="btn btn-primary font-weight-bold btn-sm" @click="handleSubmit(handleOk)" :disabled="loading">
              <i class="el-icon-loading" v-if="loading"></i>Xác nhận
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
// Date picker
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
  TAC_VU_KHAC,
  TIME_PICKER_OPTIONS,
  TIME_PICKER_OPTIONS_END,
  TYPE_TASK_NOT_TEST_INPUT,
  TYPE_TASK_TEST_INPUT
} from "@/core/option/testInputOption";
import moment from "moment-timezone";
import ModalHandleLoading from "@/view/pages/test-input/components/ModalHandleLoading.vue";
import {CREATE_OTHER_TASK, GET_FREE_ADMIN} from "@/core/services/store/tutor/tutor.module";


export default {
  name: "AddOtherTask",
  components: {ModalHandleLoading, DatePicker},
  props: {},
  data() {
    return {
      //setup
      showTimePanel: false,
      showTimePicker: null,
      showTimeRangePanel: false,
      okDisable: false,
      search_loading: false,
      fileList: [],
      type_task: TYPE_TASK_NOT_TEST_INPUT,
      TAC_VU_KHAC: TAC_VU_KHAC,
      testers: [],
      schedule: {
        tester_id: '',
        schedule: '',
        end_schedule: '',
        processing_object: ''
      },
      time_picker_options: TIME_PICKER_OPTIONS,
      time_picker_options_end: TIME_PICKER_OPTIONS_END,
      pick: false,
      timeTasks: new Map([
        [TYPE_TASK_TEST_INPUT, 30]
      ]),

      //Loading
      isShowLoading: false,
      statusSpeaking: 0,
      idSpeaking: 0,
      seconds: 60,
      loading: false
      //End Loading
    }
  },
  mounted() {
    this.resetDataDefault();
  },
  methods: {
    resetModal() {
      this.schedule = {
        type_task: '',
        tester_id: '',
        schedule: '',
        end_schedule: '',
      }
    },
    onStartDateChanged(date, type) {
      this.handleDate(date, type, "dateStart");
    },
    onEndDateChanged(date, type) {
      this.handleDate(date, type, "dateEnd");
    },
    disableOptionTimeStart(time) {
      const target = new Date(time).getTime();
      const now = Date.now();
      let currentTime = moment(time).format("HH:mm");
      return ("11:30" < currentTime && currentTime <= "13:15")
          || ("17:00" < currentTime && currentTime < "18:00")
          || ("21:45" < currentTime) || (now > target) ;
    },
    disableOptionTimeEnd(time) {
      let currentTime = moment(time).format("HH:mm");
      return time <= this.schedule.schedule || ("12:00" < currentTime && currentTime < "14:00");
    },
    handleDate(date, type, typeTime) {
      if (type !== 'date') {
        this.pick = true;
        this.showTimePanel = null
        this.showTimePicker = null
        if (typeTime == "dateStart") {
          this.schedule.end_schedule = this.calculateEndTime(date)
        }
        return;
      }
      this.showTimePanel = this.pick || moment(date).isSame(moment(date).startOf('day')) //
      this.showTimePicker = this.showTimePanel ? true : null
      this.pick = false;
    },
    calculateEndTime(date) {
      if (this.schedule.schedule > 0 && this.timeTasks.has(this.schedule.type_task)) {
        let minutes = this.timeTasks.get(this.schedule.type_task);
        return new Date(date.getTime() + minutes * 60000)
      }
      return null;
    },
    async handleOk() {
      try {
        this.loading = true
        let payload = {
          object_handle: this.schedule.processing_object,
          admin_profile_id: this.schedule.tester_id,
          start_date:moment(this.schedule.schedule).format("YYYY-MM-DD HH:mm:ss") ,
          end_date: moment(this.schedule.end_schedule).format("YYYY-MM-DD HH:mm:ss") ,
        }
        await this.$store.dispatch(CREATE_OTHER_TASK,payload)
        this.$message({
          showClose: true,
          message: 'Tạo tác vụ thành công',
          type: 'success'
        });
        this.closeModal(true)
      }catch (e) {
        this.$message({
          showClose: true,
          message: 'Tạo tác vụ thất bại',
          type: 'error'
        });
      }finally {
        this.loading = false
      }

    },
    disabledBeforeStartDate(date) {
      const today = moment().set({hour: 0, minute: 0, second: 0, millisecond: 0});
      return moment(date) < today;
    },
    disabledBeforeEndDate(date) {
      return moment(date).endOf('days') <= moment(this.schedule.schedule);
    },
    resetDataDefault() {
      this.schedule = {
        type_task: '',
        tester_id: '',
        schedule: '',
        end_schedule: ''
      }
    },

    comeBack() {
      this.$emit('comeBack')
    },
    getTestersFrees() {
      if (!this.schedule.schedule || !this.schedule.end_schedule) {
        return;
      }
      let payload = {
        start_date: moment(this.schedule.schedule).format("YYYY-MM-DD HH:mm:ss"),
        end_date: moment(this.schedule.end_schedule).format("YYYY-MM-DD HH:mm:ss"),
      }
      this.search_loading = true;
      this.$store.dispatch(GET_FREE_ADMIN, payload).then((data) => {
        this.search_loading = false;
        this.testers = data.data;
      })
    },
    closeModal(isCreateSuccessful = false){
      this.$emit('closeModal',isCreateSuccessful)
    }
  },
  computed: {
    isDisableTimeEnd() {
      return this.schedule.schedule == '' || [TYPE_TASK_TEST_INPUT].includes(this.schedule.type_task)
    },
    isDisableTester() {
      this.getTestersFrees()
      this.schedule.tester_id = null
      return (this.schedule.end_schedule == '' || this.schedule.end_schedule == null)
    }
  }
}
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
</style>